import '../globals/jquery.js'
import Rails from '@rails/ujs'
Rails.start()

import '../legacy/alert.js'
import '../legacy/global-menu.js'
import '../legacy/lp_fix_banner.js'
import '../legacy/scroll.js'
import '../legacy/search-panel.js'
import '../legacy/serviceworker-companion.js'
import '../legacy/text-overflow.js'
